import React, { useEffect, useMemo, useState } from "react";
import CommonTable from "src/business-types/grocery/components/CommonTable";
import { Table, UOMRow } from "../settingInterface";
import { Button } from "src/business-types/grocery/components/Button";
import AddUOM from "./AddUOM";
import useUOM from "src/shared/hooks/useUOM";
import LoadingScreen from "src/shared/components/LoadingScreen";
import { useSearch } from "src/business-types/grocery/components/SearchContext";
import { UOMConfig } from "src/shared/types";

const headCells: Table<UOMRow>[] = [
  { id: "S.No", label: "S.No", numeric: false, sorting: false },
  { id: "unit", label: "Units", numeric: false },
  { id: "base_unit", label: "Base Unit", numeric: false },
  { id: "count", label: "Base Unit quantity", numeric: true, align: "right" },
];

function UOM() {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { uom, loading, post, formData, setFormData } = useUOM();
  const { searchTerm } = useSearch();

  const tableData: UOMRow[] = useMemo(() => {
    if (!uom || !Array.isArray(uom)) return [];

    const search = searchTerm?.toLowerCase().trim() || "";

    const filtered = !search
      ? uom
      : uom.filter((item: UOMConfig) => {
        return item.uomName?.toLowerCase().includes(search) || item.baseUnit?.toLowerCase().includes(search) || String(item.conversionFactor)?.includes(search);
      });

    return filtered.map((item: UOMConfig, index: number) => ({
      "S.No": index + 1,
      id: item.id,
      unit: item.uomName,
      base_unit: item.baseUnit,
      count: Number(item.conversionFactor),
    }));
  }, [uom, searchTerm]);

  useEffect(() => {
    setOpenModal(false);
  }, [uom]);

  return (
    <div className='w-full h-full flex flex-col items-center bg-white rounded-2xl shadow m-1'>
      {loading && <LoadingScreen />}
      <div className='w-[97%] pt-2 flex justify-end items-end px-14'>
        <Button label='+ Measurement' onClick={() => setOpenModal(true)} />
      </div>
      <div className='w-[98%] shadow-lg flex justify-center h-fit overflow-auto'>
        <div className='w-full'>
          <CommonTable<UOMRow> data={tableData} headCells={headCells} title='' shortByTable={false} selectable={false} Action={false} />
        </div>
      </div>

      <AddUOM isOpen={openModal} onClose={() => setOpenModal(false)} post={post} formData={formData} setFormData={setFormData} />
    </div>
  );
}

export default UOM;
